import { Outlet, useLocation } from 'react-router';
import {
  FullIframeLayoutDesktopContent,
  LayoutDesktopContainer,
  LayoutDesktopContent,
} from './LayoutDesktop.styles';
import LayoutDesktopFooter from './LayoutDesktopFooter';
import LayoutDesktopHeader from './LayoutDesktopHeader';

const LayoutDesktop = () => {
  const { pathname } = useLocation();

  const isIframeFull = pathname.includes('signup');

  if (isIframeFull) {
    return (
      <FullIframeLayoutDesktopContent>
        <Outlet />
      </FullIframeLayoutDesktopContent>
    );
  }
  return (
    <LayoutDesktopContainer>
      <LayoutDesktopHeader />

      <LayoutDesktopContent>
        <div className="card">
          <Outlet />
        </div>
      </LayoutDesktopContent>

      <LayoutDesktopFooter />
    </LayoutDesktopContainer>
  );
};

export default LayoutDesktop;
